
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/shop",
      function () {
        return require("private-next-pages/search/shop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/shop"])
      });
    }
  